<template>
    <Head title="Nouveau message" />

    <AppLayout>
        <div class="p-6">
            <!-- HEADER -->
            <div class="flex justify-between mb-5">
                <h1 class="text-xl font-bold">Nouveau message</h1>

                <Link :href="route('app-messages.index')" class="text-gray-500">Retour</Link>
            </div>

            <!-- FORMULAIRE -->
            <form @submit.prevent="submit">
                <Form
                    :form="form"

                    :types="types"
                    :roles="roles"
                    :actions="actions"
                    :importances="importances"

                    :packages="packages"
                    :travels="travels"
                />

                <!-- BOUTON -->
                <div class="mt-6 flex justify-end">
                    <BotiButton type="submit" :text="'Enregistrer'" :loader="form.processing" />
                </div>
            </form>
        </div>
    </AppLayout>
</template>

<script>
    import Form from './Form.vue'
    import BotiButton from '@/Components/Button'
    import AppLayout from '@/Layouts/AppLayout.vue'

    import { Head, Link } from '@inertiajs/inertia-vue3'

    export default {
        components: {
            Head,
            Link,
            Form,
            AppLayout,
            BotiButton
        },

        props: {
            types: {
                type: Array,
                default: () => []
            },

            roles: {
                type: Array,
                default: () => []
            },

            actions: {
                type: Array,
                default: () => []
            },

            packages: {
                type: Array,
                default: () => []
            },

            travels: {
                type: Array,
                default: () => []
            },

            importances: {
                type: Array,
                default: () => []
            }
        },

        data() {
            return {
                form: this.$inertia.form({
                    title: '',
                    message: '',
                    image: null,
                    type: '',
                    importance: '',
                    action_type: '',
                    action_label: '',
                    action_payload: {},
                    roles: [],
                    dismissible: true,
                    show_once: false,
                    force_display: false,
                    priority: 0
                })
            }
        },

        methods: {
            submit() {
                this.form.post(
                    route('app-messages.store'), {
                        forceFormData: true,
                        onSuccess: () => {
                            this.$swal.fire(
                                'Message',
                                'Message créé avec succès',
                                'success'
                            )
                        }
                    }
                )
            }
        }
    }
</script>